import React from "react"

import { useFormatCurrency } from "@/formatters"
import type { Bill } from "@/services/core-api/types"

import { Box } from "@mui/material"

interface SiteBillCostProps {
  cost: Bill["cost"] | number | undefined
  currency: Bill["currency"] | undefined
}

export const SiteBillCost: React.FC<SiteBillCostProps> = ({
  cost,
  currency,
}) => {
  const { formatCurrency } = useFormatCurrency(
    {},
    { useAccountingFormatWhenNegative: false }
  )
  const formatted = formatCurrency(cost, { currency })
  const rawValue = typeof cost === "number" ? cost : Number(cost)
  const isNegative = Number.isFinite(rawValue) && rawValue < 0

  return (
    <Box
      component="span"
      sx={
        isNegative
          ? { color: (theme) => theme.palette.spectrum.green[400] }
          : undefined
      }
    >
      {formatted}
    </Box>
  )
}
